import showAppAdvertisement from 'frontend/unpoly/javascripts/modules/show_app_advertisement'
import { isNativeApp, isGoogleBot } from 'shared/javascripts/util/detection'
import session from '../util/session'
import {
  eligibleForAppRatingOverlay,
  showAppRatingOverlay,
} from 'frontend/unpoly/javascripts/modules/show_app_rating'
import { onConsentReady } from '../util/gdpr_consent'
import type { CompilerMeta } from 'types/unpoly/compiler'

let dialogShown = false
let firstVisit = true

interface LearningRemindersData {
  context: string
  remindAgain: number
  lastCompletedStep: string
  advertisement_modal_path: string
  app_rating_modal_path?: string
  internalNavigation: boolean
  referrer?: string
}

up.compiler(
  '[data-learning-reminders]',
  { priority: 1 },
  (element: HTMLElement, data: LearningRemindersData, meta: CompilerMeta) => {
    if (!meta.layer.isRoot()) {
      return
    }

    if (meta.revalidating) {
      return
    }

    if (data.context === 'thank_you') {
      session.remindAgain = -1
      return
    }

    if (up.layer.isOverlay() && !window._gdpr_testModalOpen) {
      // When rendering inside a modal, we do not want to update the layout used in the background.
      return
    }

    function resetRemindCounter(): void {
      session.remindAgain = data.remindAgain
    }

    function initRemindCounter(): void {
      session.remindAgain = data.remindAgain
    }

    function resetStep(): void {
      session.lastCompletedStep = data.lastCompletedStep
    }

    function showAppAdvertisementDialog(): void {
      resetRemindCounter()

      dialogShown = true
      showAppAdvertisement(data.advertisement_modal_path)
    }

    function fireReminderModals({ bannerFired }: { bannerFired: boolean }): void {
      if (bannerFired && firstVisit) {
        // do nothing
      } else if (isGoogleBot()) {
        // do nothing
      } else if (data.app_rating_modal_path && eligibleForAppRatingOverlay()) {
        showAppRatingOverlay(data.app_rating_modal_path)
      } else if (data.context === 'video_player' || session.lastCompletedStep !== 'none') {
        // on the video page; or user is already in the signup flow
        if (session.remindAgain! < 1) {
          if (data.internalNavigation || session.remindAgain! < 0) {
            // internal navigation or overdue
            showAppAdvertisementDialog()
          } else if (session.remindAgain === 0) {
            // user came from outside, so delay once
            session.remindAgain = 1
          }
        }
      } else if (isNativeApp()) {
        if (
          session.lastCompletedStep === 'none' &&
          data.context === 'homepage' &&
          !dialogShown &&
          !data.referrer
        ) {
          // user has just opened the native app
          showAppAdvertisementDialog()
        }
      }

      firstVisit = false
    }

    if (session.remindAgain === null) initRemindCounter()
    if (session.lastCompletedStep === null || session.lastCompletedStep === 'none') resetStep()

    return onConsentReady(fireReminderModals)
  },
)
